import { useParams } from "react-router";
import DropdownMenu from "../../component/DropdownMenu";
import Footer from "../../component/Footer";
import Navbar from "../../component/Navbar";
import {
  DataOther_1,
  DataOther_2,
  DataOther_3,
  DataOther_4,
} from "../../inc/DataOther";

const otherComponents = {
  1: DataOther_1,
  2: DataOther_2,
  3: DataOther_3,
  4: DataOther_4,
};

export default function Page() {
  const { id } = useParams();
  const Component = otherComponents[id];

  return (
    <>
      <Navbar />
      <DropdownMenu />
      <div className="relative">
        <div className="max-w-5xl mx-auto container h-full">
          {Component ? <Component /> : <span>ไม่พบข้อมูล</span>}
        </div>
      </div>
      <Footer />
    </>
  );
}
